var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","return-object":"","item-text":"name","items":_vm.sortList,"label":_vm.$t('downtime.orderBy'),"prepend-inner-icon":"mdi-sort-variant"},model:{value:(_vm.timeSort),callback:function ($$v) {_vm.timeSort=$$v},expression:"timeSort"}})
}
var staticRenderFns = []

export { render, staticRenderFns }